module.exports = __webpack_public_path__ + "static/media/tca2.833caeb9.png";